import styled from "@emotion/styled";
import { FormButton } from "..";

export const SearchButton = styled(FormButton)({
  minWidth: "10rem",
  padding: "0.5rem",
  height: "3.75rem",
});
